import absFloor from './abs-floor';

export default function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/to-int.js
// module id = 78
// module chunks = 3